import type { ErrorDisplayType } from "./error.types";
import { normalizeHttpError } from "./http-error.factory";

export function hasErrorDisplayType(
  displayTypes: ErrorDisplayType[],
  type: ErrorDisplayType,
): boolean {
  return displayTypes.includes(type);
}

export function getTranslationKeyAndDisplayTypes(error: unknown): {
  translationKey: string;
  displayTypes: ErrorDisplayType[];
} {
  const httpError = normalizeHttpError(error);
  return httpError.translationKeyAndDisplayTypes;
}
